  <div class="task-card" >
    <div class="text-white d-flex justify-content-between align-items-center">
      <div v-if="!isEditing" @click="enableEditing" class="fs-xsm text-dark fw-500">
        {{ localTitle }}
      </div>


      <input
        v-else
        ref="titleInput"
        v-model="localTitle"
        @keydown.enter="add_new_column()"
        @blur="add_new_column"
        class="form-control form-control-sm "
        type="text"
      />
    </div>
        <button class="btn btn-sm fs-xsm btn-light w-100 mx-0 text-decoration-none px-1 text-start mt-2 px-0 small shadow-sm"  @click="startAddingTask(bucket.id)">
        <i class="bi bi-plus-lg fw-bold"></i> Add task
        </button>

        <div
            v-if="isAddingTask && selected_column_id === bucket.id"
            class="mt-2"
            v-click-outside="cancelAddingTask"
          >
            <AddTaskCard
              :column_id="selected_column_id"
              @add-task="finishAddingTask"

            />
          </div>

    <div class="mt-2">
      <draggable
        v-model="bucket.tasks"
        group="tasks"
        item-key="id"
        class="d-flex flex-column gap-2"
        @change="on_drag_change"
      >
        <template #item="{ element }">
          <div v-if="element">
          <Card :task="element" :bucket="bucket" @open-task-modal="open_task_modal(element, bucket)"  @task-deleted="remove_task"  @task-updated="handleTaskUpdated" />
          </div>
        </template>
      </draggable>



    </div>
  </div>

 <div class="modal fade" :id="`task_modal_${bucket.id}`" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content bg-white p-4">
      <div class="modal-header">
        <h5 class="modal-title" id="task_modalLabel"><span id="task-title">{{ selected_task?.name }}</span></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <!-- Assignee -->
        <div class="mb-3 d-flex align-items-center" v-for="assignee in selected_task?.assignees || []" :key="assignee.id">
          <div class="me-2">
            <span class="badge bg-secondary rounded-circle px-3 py-2">{{ getInitials(assignee.full_name) }}</span>
          </div>
          <div>
            <strong id="task-assignee">{{ assignee.full_name }}</strong>
          </div>
        </div>

        <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label text-xxs">Progress</label>
        <select
          class="form-select form-select-sm text-xxs border-0 bg-light shadow-sm"
          v-model="local_task_status_id"
          @change="update_task('status', local_task_status_id)"
        >
          <option v-for="status in task_statuses" :key="status.id" :value="status.id">
            {{ status.task_name }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label text-xxs">Priority</label>
        <select
          class="form-select form-select-sm text-xxs border-0 bg-light shadow-sm"
          v-model="local_priority_status_id"
          @change="update_task('priority', local_priority_status_id)"
        >
        <span>{{ selectedPriorityName }}</span>
          <option v-for="status in priority_statuses" :key="status.id" :value="status.id">
            {{ status.priority_name }}
          </option>
        </select>
      </div>
</div>

<!-- Dates -->
<div class="row mb-3">
  <div class="col-md-6">
    <label class="form-label text-xxs">Start Date</label>
    <input
      type="date"
      class="form-control form-control-sm text-xxs border-0 bg-light shadow-sm"
      v-model="local_start_date"
      @change="update_task('start_date', local_start_date)"
    >
  </div>
  <div class="col-md-6">
    <label class="form-label text-xxs">Due Date</label>
    <input
      type="date"
      class="form-control form-control-sm text-xxs border-0 bg-light shadow-sm"
      v-model="local_due_date"
      @change="update_task('due_date', local_due_date)"
    >
  </div>
</div>

        <!-- Notes -->
           <div class="mb-3">
          <label class="form-label text-xxs mt-2">Notes</label>
          <textarea
            id="task-notes"
            class="form-control form-control-sm text-xxs rounded-3 border-0 shadow-sm bg-light"
            rows="4"
            placeholder="Type a description or add notes here"
            v-model="description"
            @blur="update_task('description', description)"
            @keydown.enter.prevent="update_task('description', description)"
          ></textarea>
           </div>

        <!-- Checklist -->
      <div class="mb-3" id="checklist-container">
        <label class="form-label text-xxs">Checklist</label>

      <div
          v-for="(item, index) in checklist_with_placeholder"
          :key="index"
          class="d-flex align-items-center mb-2"
        >
          <input
            class="form-check-input me-2"
            type="checkbox"
            :checked="item.is_completed"
            :disabled="!item.id"
            @change="toggleItem(item)"
          />

          <input
            type="text"
            class="form-control form-control-sm border-0 text-xs flex-grow-1"
            v-model="item.text"
            :placeholder="(!item.id && index === checklist_with_placeholder.length - 1) ? 'Add checklist item...' : ''"
            @keydown.enter.prevent="submit_checklist_item(item, index, true)"
            @blur="submit_checklist_item(item, index)"
            :ref="'checklistInput-' + index"
          />

          <button
            v-if="item.id || item.text.trim()"
            type="button"
            class="btn btn-sm ms-2 px-2 py-1 text-danger"
            @click="delete_check_list_item(item, index)"
          >
            <i class="bi bi-trash"></i>
          </button>
        </div>


      </div>
     <div class="">
       <label class="form-label text-xxs">Attachments</label>

         <ul class="list-group list-group-flush text-xxs w-75 border-0">
          <li
            v-for="file in task_attachments"
            :key="file.id"
            class="list-group-item d-flex align-items-center justify-content-between bg-light border-0 mb-2 shadow-sm"
          >
            <div class="d-flex align-items-center">
              <img
                v-if="isImage(file.file_name)"
                :src="file.s3_url"
                alt="preview"
                class="me-2"
                style="width: 40px; height: 40px; object-fit: cover; border-radius: 5px;"
              />
              <i v-else class="bi bi-file-earmark-text me-2 fs-4"></i>
              <div class="d-flex flex-column">
                <span class="fw-semibold">{{ file.file_name }}</span>
              </div>
            </div>

            <!-- Actions (3-dot menu placeholder) -->
            <div class="dropdown">
              <button
                class="btn btn-sm"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-three-dots-vertical"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <a class="dropdown-item" @click.prevent="downloadFile(file.id)">Download</a>
                </li>
                <li>
                  <a class="dropdown-item text-danger" @click.prevent="deleteFile(file.id)">Delete</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
     </div>



        <!-- Attachments -->
         <div class="mt-2">
            <input
              type="file"
              ref="fileInput"
              class="d-none"
              @change="handle_file_change"
            />

            <button
              class="btn btn-outline-secondary btn-sm text-xxs"
              @click="$refs.fileInput.click()"
            >
              Add attachment
            </button>
          </div>

         <div class="mb-3 mt-2">
            <form @submit.prevent="add_comment">
              <label class="form-label text-xxs mt-2">Comment</label>
              <textarea
                id="comment"
                class="form-control form-control-sm text-xxs rounded-3 border-0 shadow-sm bg-light"
                rows="3"
                placeholder="Type your message here"
                v-model="comment"
              ></textarea>

               <button class="btn btn-primary btn-sm text-xxs mt-2 float-end" type="submit">Send Comment</button>
           </form>
           </div>

<div>
  <ul>
    <li v-for="comment in comments" class="text-xxs" :key="comment.id">
      {{ comment.content }}
    </li>
  </ul>
</div>
      </div>
    </div>
  </div>
</div>